import { withNavigationWatcher } from "./contexts/navigation";
import {
  HomePage,
  TasksPage,
  ProfilePage,
  NewClientPage,
  TestFormPage,
  SignaturesPage,
  DraftGrid,
  TemplateGrid,
  ResetPassword,
  SetNewPassword,
  FormPage,
} from "./pages";

const routes = [
  {
    path: "/tasks",
    component: TasksPage,
  },
  {
    path: "/profile",
    component: ProfilePage,
  },
  {
    path: "/home",
    component: HomePage,
  },
  // {
  //   path: '/new-client',
  //   component: NewClientPage
  // },
  {
    path: "/test-form",
    component: TestFormPage,
  },
  {
    path: "/form",
    component: FormPage,
  },
  {
    path: "/signatures",
    component: SignaturesPage,
  },
  {
    path: "/drafts",
    component:DraftGrid
  },
  {
    path: "/templates",
    component:TemplateGrid
  },
  ,
  {
    path: "/reset-password",
    component:ResetPassword
  },
  {
    path: "/set-new-password",
    component:SetNewPassword
  },
];

export default routes.map((route) => {
  return {
    ...route,
    component: withNavigationWatcher(route.component),
  };
});
